import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import { darkTheme, lightTheme } from './theme';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      customProperties: true,
      minifyTheme: css => {
        return process.env.NODE_ENV === 'production'
          ? css.replace(/[\r\n|\r|\n]/g, '')
          : css;
      }
    },
    themes: {
      light: lightTheme,
      dark: darkTheme
    }
  },
  icons: {
    iconfont: 'mdi',
    values: {
      searchPrice:
        'M 17.1418 15.0848 H 16.0584 L 15.6744 14.7146 C 17.0184 13.1512 17.8274 11.1216 17.8274 8.9137 A 8.9137 8.9137 90 0 0 8.9137 -0 A 8.9137 8.9137 90 0 0 -0 8.9137 A 8.9137 8.9137 90 0 0 8.9137 17.8275 C 11.1216 17.8275 13.1512 17.0184 14.7146 15.6745 L 15.0848 16.0584 V 17.1418 L 21.9415 23.9985 L 23.9985 21.9415 L 17.1418 15.0848 M 8.9137 15.0848 C 5.4854 15.0848 2.7427 12.3421 2.7427 8.9137 C 2.7427 5.4854 5.4854 2.7427 8.9137 2.7427 C 12.3421 2.7427 15.0848 5.4854 15.0848 8.9137 C 15.0848 12.3421 12.3421 15.0848 8.9137 15.0848 H 5.4854 Z M 6.6041 10.0956 H 7.5063 C 7.5063 10.5828 8.1243 10.9978 8.8596 10.9978 C 9.5949 10.9978 10.2129 10.5828 10.2129 10.0956 C 10.2129 9.5994 9.7437 9.4189 8.7513 9.1799 C 7.795 8.9408 6.6041 8.6431 6.6041 7.389 C 6.6041 6.5815 7.2672 5.8959 8.1829 5.6658 V 4.6824 H 9.5362 V 5.6658 C 10.452 5.8959 11.1151 6.5815 11.1151 7.389 H 10.2129 C 10.2129 6.9018 9.5949 6.4868 8.8596 6.4868 C 8.1243 6.4868 7.5063 6.9018 7.5063 7.389 C 7.5063 7.8852 7.9754 8.0656 8.9678 8.3047 C 9.9242 8.5438 11.1151 8.8415 11.1151 10.0956 C 11.1151 10.9031 10.452 11.5887 9.5362 11.8188 V 12.8022 H 8.1829 V 11.8188 C 7.2672 11.5887 6.6041 10.9031 6.6041 10.0956 Z',
      receiptExport:
        'M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.26 20.74C13.09 20.18 13 19.59 13 19C13 18.32 13.12 17.64 13.34 17H6V15H14.53C15.67 13.73 17.29 13 19 13C19.68 13 20.36 13.12 21 13.34V2L19.5 3.5M18 13H6V11H18V13M18 9H6V7H18V9M19 22V20H15V18H19V16L22 19L19 22Z'
    }
  }
});
